import { fetcher } from '@commenda/utils';

export async function downloadFilesAsZip(
  fileIds: number[],
  zipFileKey: string,
  token?: string
) {
  const queryParams = new URLSearchParams();

  if (fileIds.length && zipFileKey.length) {
    queryParams.append('fileIds', fileIds.toString());
    queryParams.append('zipFileKey', zipFileKey);
  } else {
    console.error('Invalid inputs for download files as zip');
    return null;
  }

  const result = fetcher(
    `file/download-files-as-zip?${queryParams}`,
    {
      method: 'GET',
    },
    undefined
  );

  return result;
}

export async function downloadFolderFilesAsZip(
  zipFileName: string,
  folderIds?: string[],
  fileIds?: number[]
) {
  const result = fetcher(
    `file/zip`,
    {
      method: 'POST',
      body: {
        folderIds,
        fileIds,
        zipFileName,
      },
    },
    undefined
  );

  return result;
}
